

























































































































import { Prop, Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import draggable from 'vuedraggable';
import { MenuMixins } from '@/views/MenuEdit/MenuMixins';
import { IMenu } from '@/types/menu';
import EditItem from '@/views/MenuEdit/EditItem.vue';

@Component({
  name: 'NestedDraggable',
  components: { draggable, NestedDraggable, EditItem },
})
export default class NestedDraggable extends mixins(MenuMixins) {
  @Prop({
    required: false,
    type: Array,
    default: null,
  })
  list;

  @Prop({
    required: false,
    type: Array,
    default: null,
  })
  value;

  @Prop({
    required: false,
    type: Object || undefined,
    default: () => ({}),
  })
  item: IMenu | undefined;

  // @Prop({
  //   required: false,
  //   type: String,
  // })
  // name;
  // @Prop({
  //   required: false,
  //   type: String,
  // })
  // pattern;

  // 是否禁止拖拽
  @Prop({
    required: false,
    type: Boolean,
    default: null,
  })
  disabledDrag;

  // 菜单层数, 默认为 0, 递归调用时每一层 +1
  @Prop({
    required: false,
    type: Number,
    default: 0,
  })
  tier;

  newItemRecord: Record<string, IMenu> = {};
  edittingItemRecord: Record<string, IMenu> = {};
  drag: boolean = false;
  // get disabled() {
  //   return (
  //     Object.values(this.newItemRecord).some(Boolean) ||
  //     Object.values(this.edittingItemRecord).some(Boolean)
  //   );
  // }

  // this.value when input = v-model
  // this.list  when input != v-model
  get realValue() {
    return this.value ? this.value : this.list;
  }

  get dragOptions() {
    return {
      animation: 300,
      group: 'description',
      disabled: false,
      ghostClass: 'ghost',
    };
  }

  onMoveCallback(evt) {
    // 不允许从其他层移动到主菜单层
    if (evt.from !== evt.to && evt.relatedContext.component.$parent.tier === 0) {
      return false;
    }
    // 不允许跨层级拖动
    // if (evt.from !== evt.to) {
    //   return false;
    // }
  }

  // 菜单编辑 确认时
  onEditConfirm(pattern: string, $event) {
    this.$emit('edit', {
      pattern: `${pattern}/${$event.pattern}`,
      menu: $event.menu,
      onSuccess: $event.onSuccess,
    });
  }

  // 菜单新增 确认时
  onAddConfirm(pattern: string, $event) {
    this.$emit('add', {
      pattern: `${pattern}/${$event.pattern}`,
      menu: $event.menu,
      onSuccess: $event.onSuccess,
    });
  }

  // 删除一条菜单 按钮按下时
  onDelete(pattern: string, $event) {
    this.$emit('delete', {
      pattern: `${pattern}/${$event.pattern}`,
      onSuccess: $event.onSuccess,
    });
  }

  isMenuInAdditionView(completePattern: string) {
    const targetNewItem = this.newItemRecord[completePattern];
    return targetNewItem !== undefined && targetNewItem !== null;
  }

  isMenuInEditView(completePattern: string) {
    const targetNewItem = this.edittingItemRecord[completePattern];
    return targetNewItem !== undefined && targetNewItem !== null;
  }

  isMenuDisabledDelete(completePattern: string) {
    //'party/student/officea' 学生工作办公室
    //行政机构summarize/executive
    return ['dynamic', 'dynamic/notice', 'dynamic/news'].includes(completePattern);
  }

  // 退出菜单编辑状态
  toEdittingView(completePattern: string, item: IMenu) {
    this.$set(this.edittingItemRecord, completePattern, { ...item });
  }

  // 菜单编辑 在输入时
  onEditItem(completePattern: string, payload: { field: string; value: any }) {
    const { field, value } = payload;
    this.$set(this.edittingItemRecord[completePattern], field, value);
    this.$forceUpdate();
  }

  // 菜单新增 在输入时
  onEditItemNew(completePattern: string, payload: { field: string; value: any }) {
    const { field, value } = payload;
    this.$set(this.newItemRecord[completePattern], field, value);
    this.$forceUpdate();
  }

  // 添加新菜单按按下时
  toAddView(completePattern: string) {
    this.$set(this.newItemRecord, completePattern, {
      keys: [],
      name: '',
      pattern: '',
      subs: [],
      type: completePattern === '' ? 'vain' : 'html',
    });
  }

  // 菜单编辑取消时
  quitEdittingView(completePattern: string) {
    this.$set(this.edittingItemRecord, completePattern, undefined);
  }

  // 菜单添加取消时
  quitAdditionView(completePattern: string) {
    this.$set(this.newItemRecord, completePattern, undefined);
  }
}
